import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { users as getUsers } from "reduxSlices/formSubmissionSlice"
import { taskShape } from "utils/propTypeShapes"
import { TASK_FORM_DELETED_QUESTIONS_NOTE, taskAnswerValues } from "utils/taskHelpers"
import { AnsweredFormOverview } from "shared/form"

const TaskCompletedTaskForm = ({ task, taskControls }) => {
  const { answers, subform } = task
  const { deletedQuestions = [], sections } = subform

  const users = useSelector(getUsers, isEqual)

  const answerValues = taskAnswerValues(answers)

  return (
    <AnsweredFormOverview
      answers={answerValues}
      deletedQuestionsNote={TASK_FORM_DELETED_QUESTIONS_NOTE}
      deletedQuestions={deletedQuestions}
      postSectionsContent={taskControls}
      sections={sections}
      users={users}
    />
  )
}

TaskCompletedTaskForm.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskCompletedTaskForm
